import axiosInstance from "../../utils/config/config";

export const getAllForums = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllForumsRequest",
    });
    const { data } = await axiosInstance.get(`/forum/getAllForums`);
    dispatch({
      type: "getAllForumsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllForumsFailure",
      payload: true,
    });
  }
};
